<script lang="ts">
	//Design system components
	import { DaySchedule } from '@Shelly/shelly-design-system';
	//Services
	import { format } from 'svelte-i18n';
	//Helpers
	import { dateLabels, startsWeekOnSun } from 'src/helpers/date_helper';

	export let selection: number[] = [],
		mondayIndex = 1;

	const days = [],
		daysLabels = dateLabels('days');
	for (let i = 0; i < daysLabels.length; ++i) {
		let index = mondayIndex == 0 ? i - 1 : i;
		if (index < 0) index = 6;
		days.push({
			value: $format(daysLabels[i]).slice(0, 1).toUpperCase(),
			active: false,
			index,
		});
	}
	if (!startsWeekOnSun()) {
		days.push(days.shift());
	}
	const onChange = (selection: number[]) => {
		days.forEach((day) => {
			day.active = selection.indexOf(day.index) >= 0;
		});
		return days;
	};
</script>

<DaySchedule days={onChange(selection)} />
